import { Icon, type IconName } from '@tkww/orion-web-ds-graphic';
import { Body1, Editorial } from '@xo-union/tk-ui-typography';
import classNames from 'classnames';
import React, { type ReactNode } from 'react';
import Styles from './styles.scss';

interface ClassNameProps {
	container?: string;
	subContainer?: string;
	icon?: string;
	title?: string;
	text?: string;
}

interface Props {
	iconName: IconName;
	highlightTitle: string | ReactNode;
	highlightText?: string | ReactNode;
	classes?: ClassNameProps;
	iconSize?: 'sm' | 'md' | 'lg';
}

export const Highlight = ({
	iconName,
	highlightTitle,
	highlightText,
	classes = {},
	iconSize = 'md',
}: Props) => {
	const {
		container = '',
		subContainer = '',
		icon = '',
		title = '',
		text = '',
	} = classes;

	return (
		<div className={classNames(Styles.container, container)}>
			<Icon
				name={iconName}
				className={classNames(Styles.icon, icon)}
				size={iconSize}
				data-testid={`highlight-icon-${iconName}`}
				aria-label="highlight"
			/>
			<div className={classNames(Styles.subContainer, subContainer)}>
				{
					<>
						<Editorial bold className={title}>
							{highlightTitle}
						</Editorial>
						{highlightText ? (
							<Body1 className={text}>{highlightText}</Body1>
						) : null}
					</>
				}
			</div>
		</div>
	);
};
